import React from "react";
import {ProposalFields} from "./add_proposal_steps/ProposalFields";
import {AddProposalServices} from "./add_proposal_steps/AddProposalServicesTabs";
import {AddSettings} from "./add_proposal_steps/AddSettings";
import {Form, message, Modal, Steps, Tabs} from "antd";

const moment = require('moment');
const Step = Steps.Step;
const {TabPane} = Tabs;

class TabStepsProposalForm extends React.Component {
    state = {
        data: [],
        visible: false,
        service_date: moment().format('YYYY-MM-DD'),
        confirmLoading: false,
        proposal: {},
        current: 0,
    };
    completeForm = () => {
        message.success('Proposal Added Successfully!');
        this.props.fetch();
        this.props.setModelVisible();
        this.setState({current: 0})
    };

    onCloseMdl = () => {
        this.props.setModelVisible();
        this.setState({current: 0})
    };

    setProposal = (data) => {
        this.setState({proposal: data});
    };

    next() {
        const current = this.state.current + 1;
        this.setState({current});
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({current});
    }

    render() {
        const {current, proposal} = this.state;
        return (
            <Modal maskClosable={false} title={"Create Proposal"} style={{top: 5}} className="create-quote-btn step-modal tab-proposal-mdl"
                   visible={this.props.visible} onCancel={() => this.onCloseMdl()} footer={false}
                   width="95%" destroyOnClose={true}>
                <div className="row m-0">
                    <div className="col-12 step-work-form">
                        <Tabs defaultActiveKey="0" activeKey={`${current}`} type="card">
                            <TabPane key="0" tab={<p className="step-tab-title">Site/Bill To/Settings</p>}>
                                <div className="steps-content">
                                    <ProposalFields onClose={() => this.onCloseMdl()}
                                                    onNext={() => this.next()}
                                                    setProposal={(data) => this.setProposal(data)}/>
                                </div>
                            </TabPane>
                            <TabPane key="1" tab={<p className="step-tab-title">Service Info</p>}>
                                <div className="steps-content">
                                    <AddProposalServices onClose={() => this.onCloseMdl()} onNext={() => this.next()}
                                                         onBack={() => this.prev()} proposal={proposal}/>
                                </div>
                            </TabPane>
                            <TabPane key="2" tab={<p className="step-tab-title">Legal/Admin Info</p>}>
                                <div className="steps-content">
                                    <AddSettings onClose={() => this.onCloseMdl()} onNext={() => this.next()}
                                                 onBack={() => this.prev()} onComplete={() => this.completeForm()} proposal={proposal}/>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </Modal>

        );
    }
}

export const TabStepsProposal = Form.create()(TabStepsProposalForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/TabStepsProposal.jsx